import React, {useState, useEffect, useCallback, useRef} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {showToast, downloadFile} from '../../common/app_common';
import {InputAuto} from '../../common/component_common';
import {getApiReceiveEdgeKeyword, putApiReceiveEdgeIdConfig} from '../../common/fetch_api/coverage';
import '../../common/css/markdown.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkToc from 'remark-toc';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';
import rehypeSanitize from 'rehype-sanitize';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { BsFullscreen, BsFullscreenExit } from 'react-icons/bs';

export const ReceiveEdgeEditModal = ({edgeInfo, show, handleClose, update}) => {
    
    const edgeName = useRef('');

    const [edgeProduct, setEdgeProduct] = useState('');
    const [tabIndex, setTabIndex] = useState('Memo');
    const [markDown, setMarkDown] = useState('');
    
    const memoTxt = useRef("");
    const [memoLen, setMemoLen] = useState(0);
    
    const [completeProduct, setCompleteProduct] = useState([]);

    const onClickSiteSave = () => {
        const postData = {name: edgeName.current.value, product: edgeProduct, memo: memoTxt.current.value};
        Promise.resolve( putApiReceiveEdgeIdConfig(edgeInfo.id, postData) )
        .then( data => {
            if( JSON.stringify(postData) === JSON.stringify(data) )
            {
                closeModal();
                update();
            }
        });
    }

    const onKeyUpMemo = useCallback((e) => {
        setMemoLen(memoTxt.current.value.length);
        setMarkDown(memoTxt.current.value);
    }, [memoTxt]);

    useEffect( () => {
        edgeName.current.value = edgeInfo.name;
        memoTxt.current.value = edgeInfo.memo;
        
        setMarkDown(edgeInfo.memo);
        setMemoLen(edgeInfo.memo.length);
        setEdgeProduct(edgeInfo.product);

        Promise.resolve( getApiReceiveEdgeKeyword() )
        .then( data => {
            setCompleteProduct(data.product);
        });

    }, []);
    
    const onClickSiteCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        setMemoLen(0);
        setTabIndex('Memo');
        setMarkDown('');
        handleClose();
        show = false;
    }

    return (
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Edit Receive Edge</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickSiteCancel}></Button>
            </Modal.Header>
            <Modal.Body className="create-site">
                <div className="d-flex">
                    <div className="col-3 label-box">Name</div>
                    <div className="col-9">
                        <input className="form-control input-box" maxLength="32" type="text" ref={edgeName}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Product</div>
                    <div className="col-9">
                        <InputAuto className="" lenMax="32" pholder="" data={completeProduct} selectedVal={edgeProduct} setSelectedVal={setEdgeProduct} />
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="Memo"
                    transition={true}
                    activeKey={tabIndex}
                    onSelect={(k) => setTabIndex(k)}
                    className="mt-3" >
                    <Tab eventKey="Memo" title="Memo"/>
                    <Tab eventKey="Editor" title="Editor"/>
                </Tabs>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Memo'?'':'d-none'}`} >
                    <ReactMarkdown className='manager-text-box markdown-body'
                        children={markDown}
                        remarkPlugins={[remarkGfm, remarkToc]}
                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                    />
                </div>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Editor'?'':'d-none'}`} >
                    <textarea className="manager-text-box" maxLength="65535" ref={memoTxt} onChange={onKeyUpMemo}></textarea>
                </div>
                <div className="text-end">{`${memoLen} / 65535`}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickSiteCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickSiteSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    )
}

export const ReceiveEdgeDetailModal = ({edgeInfo, show, handleClose, update}) => {
    
    const [fullscreen, setFullscreen] = useState(false);
    const [markDown, setMarkDown] = useState('');
    const edgeName = useRef('');
    
    const onClickSiteSave = () => {

        // downloadFile(contents, `${filename}_Memo`);

        // const postData = {name: edgeName.current.value, product: edgeProduct, memo: memoTxt.current.value};
        // Promise.resolve( putApiReceiveEdgeIdConfig(edgeInfo.id, postData) )
        // .then( data => {
        //     if( JSON.stringify(postData) === JSON.stringify(data) )
        //     {
        //         closeModal();
        //         update();
        //     }
        // });
    }

    useEffect( () => {
        edgeName.current.value = edgeInfo.name;        
        setMarkDown(edgeInfo.memo);
    }, []);
    
    const onClickSiteCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        setMarkDown('');
        handleClose();
        show = false;
        setFullscreen(false);
    }

    const onClickToggleFull = () => {
        setFullscreen(!fullscreen);
    }

    return (
        <Modal
            show={show}
            fullscreen={fullscreen}
            keyboard={true}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Detail Receive Edge (TBD)</h6>
                <div>
                    {!fullscreen&&<BsFullscreen cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreen>}
                    {fullscreen&&<BsFullscreenExit cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreenExit>}
                    <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
                </div>
            </Modal.Header>
            <Modal.Body className="create-site">
                <div className="d-flex">
                    <div className="col-3 label-box">Name</div>
                    <div className="col-9">
                        <input className="form-control input-box" maxLength="32" type="text" ref={edgeName}/>
                    </div>
                </div>
                <div className={`d-flex manager-markdown-area mt-2`} >
                    <ReactMarkdown className='manager-text-box markdown-body'
                        children={markDown}
                        remarkPlugins={[remarkGfm, remarkToc]}
                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickSiteCancel}>Close</Button>
                <Button variant="success" className="btn-sm" onClick={onClickSiteSave}>Export</Button>
            </Modal.Footer>
        </Modal>
    )
}